export default defineNuxtPlugin(() => {
  // Only run on client side
  if (typeof window === 'undefined') return

  // Inject immediate loading screen CSS and HTML
  const loadingCSS = `
    <style id="immediate-loader-styles">
      #immediate-loader {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
            background: #16191E;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        color: white;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        transition: opacity 0.5s ease-out;
      }

      #immediate-loader .logo {
        width: 200px;
        height: 200px;
        border-radius: 50%;
        margin-bottom: 30px;
        position: fixed;
        left: 50vw;
        top: 50vh;
        transform: translate(-50%, -50%);
        object-fit: contain;
      }

      #immediate-loader .spinner {
        width: 50px;
        height: 50px;
        border: 5px solid rgba(255, 255, 255, 0.3);
        border-top: 5px solid white;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        position: fixed;
        top: calc(50vh + 150px);
        transform: translate(-50%, -50%);
      }

      #immediate-loader .text {
        position: fixed;
        left: 50vw;
        top: calc(50vh + 120px);
        transform: translate(-50%, -50%);
        font-size: 24px;
        font-weight: 300;
        opacity: 0.9;
      }

      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      @keyframes pulse {
        0%, 100% { 
          transform: scale(1);
          opacity: 1; 
        }
        50% { 
          transform: scale(1.05);
          opacity: 0.8; 
        }
      }

      @media (max-width: 768px) {
        #immediate-loader .logo {
          width: 50px;
          height: 50px;
        }
        #immediate-loader .text {
          font-size: 24px;
        }
      }
    </style>
  `

  const loadingHTML = `
    <div id="immediate-loader">
      <img class="logo" src="https://huamei2001.oss-cn-shenzhen.aliyuncs.com/icons/%E5%8D%8E%E7%BE%8E%E4%BA%91logo.png" alt="华美云" />
      <div class="spinner"></div>
      <div class="text">正在加载...</div>
    </div>
  `

  // Inject CSS into head immediately
  document.head.insertAdjacentHTML('beforeend', loadingCSS)
  
  // Inject HTML into body immediately
  document.body.insertAdjacentHTML('afterbegin', loadingHTML)

  // Hide loader when app is ready
  const hideLoader = () => {
    const loader = document.getElementById('immediate-loader')
    const styles = document.getElementById('immediate-loader-styles')
    
    if (loader) {
    //   loader.style.opacity = '0'
      setTimeout(() => {
        loader.remove()
        if (styles) styles.remove()
      }, 500)
    }
  }

  // Multiple ways to detect when app is ready
  const startTime = Date.now()
  
  // Hide after Vue app is mounted (this plugin runs after mount)
  setTimeout(hideLoader, 100)
  
  // Fallback: hide after maximum 8 seconds
  setTimeout(hideLoader, 8000)
  
  // Hide when window fully loads
  if (document.readyState === 'complete') {
    setTimeout(hideLoader, 1500)
  } else {
    window.addEventListener('load', () => {
      setTimeout(hideLoader, 1500)
    })
  }

  // Performance logging
  console.log(`⚡ Immediate loader injected in ${Date.now() - startTime}ms`)
}) 